import { Team, VetoStep } from '../types/match.types';

/**
 * @deprecated This function is deprecated and will be removed in a future version.
 * Use the MappoolContext to fetch season-specific mappools instead.
 * Components should use useMappoolContext().getMappool(season) to get the correct mappool.
 */
export const getMapPool = (vetoLog: string): string[] => {
  console.warn('getMapPool is deprecated. Use MappoolContext instead.');
  // Fallback for backward compatibility - Season 3 mappool
  return ["Ancient", "Dust2", "Inferno", "Mirage", "Nuke", "Overpass", "Train"];
};

export const parseVetoLog = (
  vetoLog: string,
  team1: Team,
  team2: Team
): VetoStep[] => {
  if (!vetoLog) return [];

  // First, let's clean up the veto log and handle concatenated lines
  let cleanedVetoLog = vetoLog;

  // Handle concatenated lines with timestamps by splitting on timestamp patterns
  // This handles cases like "Ancient19:23:109 - Multihunters Elite got..."
  cleanedVetoLog = cleanedVetoLog.replace(
    /(\d{1,2}:\d{2}:\d{1,3})\s*-\s*/g,
    "\n$1 - "
  );

  // Also handle cases where map names are directly concatenated with timestamps
  // Look for pattern: MapName + timestamp + " - " + rest
  cleanedVetoLog = cleanedVetoLog.replace(
    /([A-Za-z]+)(\d{1,2}:\d{2}:\d{1,3})\s*-\s*/g,
    "$1\n$2 - "
  );

  const lines = cleanedVetoLog.split("\n").filter((line) => line.trim());
  const steps: VetoStep[] = [];

  lines.forEach((line, index) => {
    const trimmedLine = line.trim();
    if (!trimmedLine) return;

    let processedLine = trimmedLine;

    // Remove timestamp prefix if present (e.g., "19:23:109 - ")
    if (trimmedLine.includes(" - ")) {
      const dashIndex = trimmedLine.indexOf(" - ");
      const beforeDash = trimmedLine.substring(0, dashIndex);
      // Check if before dash looks like a timestamp
      if (/^\d{1,2}:\d{2}:\d{1,3}$/.test(beforeDash.trim())) {
        processedLine = trimmedLine.substring(dashIndex + 3);
      }
    }

    let team: Team | undefined;
    let type: "ban" | "pick" | "side" | "decider" | undefined;
    let map: string = "";
    let side: string | undefined;

    if (processedLine.includes(" removed ")) {
      const parts = processedLine.split(" removed ");
      const teamName = parts[0];
      map = parts[1];
      type = "ban";
      team = [team1, team2].find((t) => t.teamName === teamName);
    } else if (processedLine.includes(" picked ")) {
      const parts = processedLine.split(" picked ");
      const teamName = parts[0];
      map = parts[1];
      type = "pick";
      team = [team1, team2].find((t) => t.teamName === teamName);
    } else if (processedLine.includes(" choose to start ")) {
      // Handle both formats:
      // "AMO Esport choose to start CT" (season 1)
      // "Unsigned Puggers choose to start T on Anubis" (season 2)
      const regexWithMap = /(.+) choose to start (\w+) on (.+)/;
      const regexWithoutMap = /(.+) choose to start (\w+)$/;

      let match = processedLine.match(regexWithMap);
      if (match) {
        // Season 2 format - map is specified
        const teamName = match[1];
        side = match[2];
        map = match[3];
        type = "side";
        team = [team1, team2].find((t) => t.teamName === teamName);
      } else {
        match = processedLine.match(regexWithoutMap);
        if (match) {
          // Season 1 format - find the last decider step
          const teamName = match[1];
          side = match[2];
          const lastDeciderStep = steps
            .slice()
            .reverse()
            .find((s) => s.type === "decider");
          map = lastDeciderStep ? lastDeciderStep.map : "";
          type = "side";
          team = [team1, team2].find((t) => t.teamName === teamName);
        }
      }
    } else if (processedLine.includes(" was left over")) {
      // Season 1 format: "Ancient was left over"
      map = processedLine.split(" was left over")[0];
      type = "decider";
    } else if (
      processedLine.includes(" got ") &&
      processedLine.includes(" as the last map")
    ) {
      // Season 2 format: "Multihunters Elite got Anubis as the last map"
      const regex = /(.+) got (.+) as the last map/;
      const match = processedLine.match(regex);
      if (match) {
        const teamName = match[1];
        map = match[2];
        type = "decider";
        team = [team1, team2].find((t) => t.teamName === teamName);
      }
    } else if (
      processedLine.includes(" got ") &&
      processedLine.includes(" as the decider")
    ) {
      // Alternative format: "Linx Legacy HP got Dust2 as the decider"
      const regex = /(.+) got (.+) as the decider/;
      const match = processedLine.match(regex);
      if (match) {
        const teamName = match[1];
        map = match[2];
        type = "decider";
        team = [team1, team2].find((t) => t.teamName === teamName);
      }
    }

    if (map && type) {
      steps.push({ map, side, type, team, order: index + 1 });
    }
  });

  return steps;
};

export const formatRoundReason = (reason: string) => {
  switch (reason) {
    case "TerroristsWin":
      return "T Win";
    case "CTsWin":
      return "CT Win";
    case "TargetBombed":
      return "Bomb Exploded";
    case "BombDefused":
      return "Bomb Defused";
    case "RoundDraw":
      return "Round Draw";
    default:
      return reason;
  }
};